

























































































































































































































































































































import { Component } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";
import { mapActions, mapGetters } from "vuex";

import { auth } from "@/config/host.config";
import { INavRoute, IRoute } from "@/@types/routes/routes";
import GetRoutes from "@/modules/routes/getRoutes";

import LangusgeSwitcher from "./LangusgeSwitcher.vue";
import AccountModal from "./AccountModal.vue";
import { BDropdown } from "bootstrap-vue";
import {
  isNavSectionHidden,
  isNavChildHidden,
  getNavSingleChild,
  getNavSingleChildLabel,
  isFaqHidden,
  isBigNavbarHidden,
} from "@/services/featureConfig";
@Component({
  methods: {
    ...mapActions({
      onLogout: "onLogout",
    }),
  },
  computed: {
    ...mapGetters({
      routerState: "ROUTER_STATE",
      roomServiceNewCount: "getRoomServiceNewCount",
      roomServiceEmergencyCount: "getRoomServiceEmergencyCount",
    }),
  },
  mixins: [GetRoutes],
  components: {
    LangusgeSwitcher,
    AccountModal,
  },
})
export default class HeaderComponent extends GetRoutes {
  onLogout!: () => void;
  routerState!: IRoute[];
  roomServiceNewCount!: number;
  roomServiceEmergencyCount!: number;
  navRoutes: INavRoute[] = [];

  isNavHidden = isNavSectionHidden;
  isNavChildHidden = isNavChildHidden;
  navSingleChild = getNavSingleChild;
  navSingleChildLabel = getNavSingleChildLabel;
  faqHidden = isFaqHidden;
  bigNavbarHidden = isBigNavbarHidden;

  $refs!: {
    route: BDropdown;
    map: BDropdown;
    service: BDropdown;
    media: BDropdown;
    hotel: BDropdown;
    mails: BDropdown;
  };

  userName = sessionStorage.getItem("login");
  // userName = getPayload(this.$store.getters.getAccess);
  refreshToggle = this.$store.getters.getRefreshToken ? true : false;

  get getUserRules(): string {
    let userRules = this.$store.getters.getUserRules;
    if (!userRules) userRules = localStorage.getItem("userRoles");
    return userRules;
  }

  openAccount(): void {
    this.$nextTick(() => this.$bvModal.show("account-modal"));
  }

  logout(): void {
    const url = auth.logout;
    axios
      .post(url)
      .then((res) => {
        this.onLogout();
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err.message);
      });

    localStorage.removeItem("login");
    localStorage.removeItem("userRoles");
    this.$router.push("/login");
  }

  changeCloseBtn(): void {
    document.querySelectorAll(".close").forEach((el) => {
      el.classList.add("btn", "btn-primary");
    });
  }

  mounted(): void {
    setTimeout(() => {
      this.changeCloseBtn();
    }, 500);
    if (localStorage.getItem("refreshToken")) {
      this.startGetRoutes();
    }
    this.$watch(
      "routerState",
      function () {
        console.log("Нашлись изменения в routerState");
        for (let i = 0; i < this.routerState.length; i++) {
          if (this.routerState[i].children.length) {
            this.navRoutes.push({
              name: this.routerState[i].name,
              path: this.routerState[i].children[0],
            });
          } else {
            this.navRoutes.push({
              name: this.routerState[i].name,
              path: this.routerState[i].name,
            });
          }
        }
      },
      { deep: true }
    );
  }
}
